export default __webpack_public_path__ + "static/media/dashboard.d79405bf.svg";